import * as Yup from 'yup';

export const LoginSchema = Yup.object().shape({
  email: Yup.string().email('Invalid email').required('Email is required'),
  password: Yup.string().required('Password is required'),
});

export const SignupSchema = Yup.object().shape({
  name: Yup.string()
    .max(25, 'Maximum 25 characters')
    .required('Name is required'),
  email: Yup.string().email('Invalid email').required('Email is required'),
  password: Yup.string()
    .min(8, 'Minimum 8 characters are required')
    .required('Password is required'),
});

export const MobileSchema = Yup.object().shape({
  mobileNumber: Yup.string()
    .min(10, 'Invalid mobile number')
    .max(10, 'Mobile number should be 10 digit')
    .required('Mobile number is required'),
  otp: Yup.string(),
});

export const ForgotPasswordSchema = Yup.object().shape({
  email: Yup.string().email('Invalid email').required('Email is required'),
});

export const ProjectInfoSchema = Yup.object().shape({
  projectInfo: Yup.object().shape({
    projectId: Yup.string().required('Project Id is required'),
    projectName: Yup.string().required('Project name is required'),
    category: Yup.string().required('Category is required'),
    location: Yup.string().required('Site location is required'),
  }),
});

export const SendInviteSchema = Yup.object().shape({
  email: Yup.string().email('Email is invalid'),
  role: Yup.string().required('Role is required'),
});

export const UploadDocSchema = Yup.object().shape({
  docNo: Yup.string().required('Doc number is required'),
  title: Yup.string().required('Title is required'),
  rev: Yup.string().required('revision is required'),
  file: Yup.string().required('No file is selected'),
});
